import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Image from "../assets/img/close-icon.svg";
import Search from "../assets/img/search-icon.svg";
import Grade from "../assets/img/grade-1.svg";
import Star from "../assets/img/student-profile.svg";
import Select from "react-select";

import Tick from "../assets/img/tick-fade.svg";
import ColorTick from "../assets/img/status-check.svg";
import { useEffect } from "react";
import {
  GetFunction,
  SubmitResponse,
  handleimageUrl,
} from "../utils/ApiFunctions";
import { useState } from "react";
import { useLocalization } from "./Localization/Localization";
import { useParams } from "react-router-dom";
import { GetValueLable, GetValueLableWithId } from "../utils/Helper";
function SelectPerson(props) {
  const { assessmentType } = useParams();
  const [sectionList, setSectionList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [rolename, setRoleId] = useState(
    props?.defaultRole ? props?.defaultRole : ""
  );
  const [roleList, setRoleList] = useState([]);
  const [options, setOptions] = useState([]);
  const [starList, setStartList] = useState([]);

  const [selectStarStudent, SetSelectedStudentData] = useState([]);
  const [selectId, setSelectedIds] = useState([]);
  const [keywords, setKeyWords] = useState("");

  async function GetRoleList() {
    const res = await GetFunction(`role/getAll?type=main&pages=all`);
    if (res.status == 200) {
      if (assessmentType == "assessment" || assessmentType == "lab") {
        const data = res?.data?.data?.filter((data) => data?.name == "star");

        setRoleList(data);
      } else {
        const data = res?.data?.data?.filter(
          (data) => data?.name !== "shopstaff"
        );

        setRoleList(data);
      }
    }
  }

  async function GetPersonList() {
    const res = await GetFunction(
      `search/searchAllRole?roleName=${rolename}&searchText=${keywords}&school=${props?.schoolId}&classId=${className}&section=${sectionName}`
    );
    if (res.status == 200) {
      setStartList(res?.data?.data);
    }
  }

  const saveData = (val) => {
    if (selectId.includes(val?._id)) {
      SetSelectedStudentData(
        selectStarStudent.filter(
          (selectedPerson) => selectedPerson?._id !== val?._id
        )
      );
      setSelectedIds(selectId?.filter((vals) => vals !== val?._id));
    } else {
      SetSelectedStudentData((pre) => [...pre, val]);
      setSelectedIds((pre) => [...pre, val._id]);
    }
  };

  useEffect(() => {
    if (props.show) {
      GetRoleList();
    }
  }, [props.show]);

  useEffect(() => {
    if (rolename && props?.schoolId) {
      GetPersonList();
      GetClassList();
    }
  }, [rolename, keywords, className, sectionName, props.schoolId]);
  const { t } = useLocalization();

  useEffect(() => {
    let roles = GetValueLable(roleList, ["name"]);
    const rolesToExclude = [
      "star",
      "financeadmin",
      "security",
      "parent",
      "shop",
      "guardian",
    ];

    roles = roles.filter((val) => !rolesToExclude.includes(val.value));

    setOptions(roles);
  }, [roleList]);

  const GetClassList = async () => {
    const res = await GetFunction(
      `/class/getAllClass?schoolid=${props.schoolId}&pages=all`
    );
    if (res.status == 200) {
      setClassList(GetValueLableWithId(res?.data?.data, ["_id", "name"]));
    }
  };

  const GetSectionList = async () => {
    const res = await GetFunction(
      `/class/section/getall?schoolid=${props.schoolId}&pages=all&classId=${className}`
    );
    if (res.status == 200) {
      setSectionList(
        GetValueLableWithId(res?.data?.data?.data, ["_id", "name"])
      );
    }
  };

  useEffect(() => {
    if (className) {
      GetSectionList();
    }
  }, [className]);

  console.log("--------ddd--", options);
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className=""
    >
      <Modal.Body>
        <div className="edit-profile   select-user p-4 ">
          <h2>{t("select_person")} </h2>

          <button
            closeButton
            className="btn-btn-close"
            onClick={() => props?.onHide()}
          >
            <img src={Image} alt="" />
          </button>
          <div className="filter-section-data">
            <Row>
              <Col md={12} className="pe-0">
                <div className="form-group">
                  <Select
                    // isDisabled={props?.defaultRole ? true : false}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // Set the desired z-index value
                      }),
                      control: (provided) => ({
                        ...provided,
                        borderColor: "#AEAEAE", // Set border color to #AEAEAE
                        "&:hover": {
                          borderColor: "#AEAEAE", // Set border color when hovering
                        },
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        borderColor: "#AEAEAE", // Set indicator border color to #AEAEAE
                        "&:hover": {
                          borderColor: "#AEAEAE", // Set indicator border color when hovering
                        },
                      }),
                    }}
                    className="mb-2"
                    options={options}
                    name="rolename"
                    onChange={(option) => {
                      if (!props?.prevoiusdata) {
                        setSelectedIds("");
                        SetSelectedStudentData("");
                      }

                      setRoleId(option.value);
                      setClassName("");
                      setSectionName("");
                    }}
                    value={options.find((option) => option.value === rolename)}
                  />
                  {/* <select
                    value={rolename}
                    onChange={(e) => {
                      setSelectedIds("");
                      SetSelectedStudentData("");

                      setRoleId(e.target.value);
                    }}
                  >
                     <option selected value="" disabled>
                      {t("select_role")}
                    </option>
                    {roleList &&
                      roleList?.map((val, i) => (
                        <option value={val?.name}>{val.displayName}</option>
                      ))}
                  </select> */}
                </div>
              </Col>
              {rolename == "star" && (
                <>
                  <Col md={6} className="pe-0">
                    <div className="form-group">
                      <Select
                        placeholder={t("class")}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999, // Set the desired z-index value
                          }),
                          control: (provided) => ({
                            ...provided,
                            borderColor: "#AEAEAE", // Set border color to #AEAEAE
                            "&:hover": {
                              borderColor: "#AEAEAE", // Set border color when hovering
                            },
                          }),
                          indicatorsContainer: (provided) => ({
                            ...provided,
                            borderColor: "#AEAEAE", // Set indicator border color to #AEAEAE
                            "&:hover": {
                              borderColor: "#AEAEAE", // Set indicator border color when hovering
                            },
                          }),
                        }}
                        options={classList}
                        name="classList"
                        onChange={(option) => {
                          setSectionName("");
                          setSectionList([]);
                          setClassName(option.value);
                        }}
                        value={classList?.find(
                          (option) => option.value === className
                        )}
                      />
                    </div>
                  </Col>
                  <Col md={6} className="pe-0">
                    <div className="form-group">
                      <Select
                        placeholder={t("section")}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999, // Set the desired z-index value
                          }),
                          control: (provided) => ({
                            ...provided,
                            borderColor: "#AEAEAE", // Set border color to #AEAEAE
                            "&:hover": {
                              borderColor: "#AEAEAE", // Set border color when hovering
                            },
                          }),
                          indicatorsContainer: (provided) => ({
                            ...provided,
                            borderColor: "#AEAEAE", // Set indicator border color to #AEAEAE
                            "&:hover": {
                              borderColor: "#AEAEAE", // Set indicator border color when hovering
                            },
                          }),
                        }}
                        options={sectionList}
                        name="sectionList"
                        onChange={(option) => {
                          setSectionName(option.value);
                        }}
                        value={sectionList.find(
                          (option) => option.value === sectionName
                        )}
                      />
                    </div>
                  </Col>
                </>
              )}

              <Col md={12} className="mt-0 mb-2">
                {/* <Col md={12} className="border-top-1"> */}
                <div className="form-group">
                  <input
                    type="text"
                    placeholder={t("search")}
                    value={keywords}
                    onChange={(e) => setKeyWords(e.target.value)}
                  />
                  <img className="ipt-icn img-fluid" src={Search} />
                </div>
              </Col>
            </Row>
          </div>

          {starList &&
            starList?.map((val, i) =>
              selectId?.includes(val?._id) ? (
                <div
                  key={i}
                  className="star-list-selct active"
                  onClick={(e) => {
                    e.preventDefault();
                    saveData(val);
                  }}
                >
                  <div className="star-profile-1">
                    <img
                      src={
                        val?.user?.profilePic != ""
                          ? handleimageUrl(val?.profilePic)
                          : Star
                      }
                    />
                  </div>
                  <div className="w-100">
                    <h6>{val?.name} </h6>
                    <p className="p-0">ID: {val?.uniqueId} </p>
                  </div>

                  <img src={ColorTick} />
                </div>
              ) : (
                <div
                  className="star-list-selct "
                  onClick={(e) => {
                    e.preventDefault();
                    saveData(val);
                  }}
                >
                  <div className="star-profile-1">
                    <img
                      src={
                        val?.user?.profilePic != ""
                          ? handleimageUrl(val?.profilePic)
                          : Star
                      }
                    />
                  </div>
                  <div className="w-100 ">
                    <h6>{val?.name} </h6>
                    <p className="p-0">ID: {val?.uniqueId} </p>
                  </div>
                  <img src={Tick} />
                </div>
              )
            )}

          <div className="text-center mt-4">
            <button
              className="btn-btn-primary "
              onClick={() => {
                props?.Selectdata(selectStarStudent, rolename, selectId);

                props?.onHide();
              }}
            >
              {t("continue")}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SelectPerson;
